import React, { useState } from 'react'
import { FileDropBox } from '../../../../components/File/File'
import Button from '../../../../components/Button/Button'
import { Buffer } from 'buffer'
import './whiteLabelAssets.scss'
window.Buffer = window.Buffer || Buffer

export default function WhiteLabelAssets({ presentImage, onFile, caption }) {
  const [logoFile, setLogoFile] = useState(presentImage)
  const remove = () => {
    onFile('')
    setLogoFile('')
  }

  const uploadFile = async (file) => {
    const reader = new FileReader()
    reader.onload = async () => {
      const binaryStr = reader.result
      const base64string = await Buffer.from(binaryStr).toString('base64')
      const imageUri = `data:${file.type};base64,${base64string}`
      onFile(imageUri)
      await setLogoFile(imageUri)
    }
    reader.readAsArrayBuffer(file)
  }

  return (
    <div>
      {logoFile ? (
        <div>
          <h3>{ caption }</h3>
          <div className='thumbnail'>
            <img src={logoFile} alt="logoImage" />
          </div>
          <Button variant="primary" onClick={remove} label="Remove" />
        </div>
      ) : (
        <div>
          <h2>{`Upload ${caption}: (optional)`}</h2>
          <p className='upload-note'><i>(Please provide square logo image for best experience)</i></p>
          <FileDropBox onDrop={uploadFile} fileSize={1048576} />
        </div>
      )}
    </div>
  )
}

WhiteLabelAssets.defaultProps = {
  presentImage: '',
  caption: '',
}
